// src/index.jsx

// First import all dependencies
import "./style.css";
import ReactDOM from "react-dom/client";
import { StrictMode } from "react";
import FrameSim from "./FrameSim.jsx";
import { ControlProvider } from "./ControlContext.jsx";

// Log version info
console.log(
  `%c SimpleFrame ${__APP_VERSION__} [${__GIT_BRANCH__}] build #${__BUILD_NUMBER__} (${__COMMIT_DATE__})`,
  'background: #222; color: #bada55; padding: 4px 8px; border-radius: 3px;'
);

// Then create the message queue system
const createMessageQueue = () => {
  let queue = [];
  let hasNotifiedReady = false;

  const processMessage = (event) => {
    const appEvent = new CustomEvent("iframe-message", { detail: event });
    window.dispatchEvent(appEvent);
  };

  const handleMessage = (event) => {
    if (!hasNotifiedReady) {
      queue.push(event);
      return;
    }
    processMessage(event);
  };

  const initialize = () => {
    window.addEventListener("message", handleMessage, false);
  };

  const notifyReady = () => {
    if (hasNotifiedReady) return;

    hasNotifiedReady = true;
    console.log("Processing queued messages:", queue.length);

    while (queue.length > 0) {
      const event = queue.shift();
      processMessage(event);
    }

    if (window.parent) {
      window.parent.postMessage(
        JSON.stringify({
          type: "app-ready",
          message: "Iframe is ready for messages",
        }),
        "*"
      );
      console.log("Sent app-ready message");
    }
  };

  const cleanup = () => {
    window.removeEventListener("message", handleMessage);
    queue = [];
  };

  return {
    initialize,
    notifyReady,
    cleanup,
  };
};

// Create message queue instance
const messageQueue = createMessageQueue();

// Initialize React
const root = ReactDOM.createRoot(document.querySelector("#root"));

// Add event listener for when ControlProvider is ready
window.addEventListener("control-provider-ready", () => {
  console.log("ControlProvider ready event received");
  messageQueue.notifyReady();
});

// Initialize message queue
messageQueue.initialize();

// Clean up on window unload
window.addEventListener("unload", messageQueue.cleanup);

// Render the app
root.render(
  <StrictMode>
    <ControlProvider>
      <FrameSim />
    </ControlProvider>
  </StrictMode>
);
